import { Grid } from "@/shared/components/common/Grid/Grid";
import { GridItem } from "@/shared/components/common/GridItem/GridItem";
import TopEmployeesDepartment from "./components/cards/TopEmployeesDepartment/TopEmployeesDepartment";
import TopEmployeesCompany from "./components/cards/TopEmployeesCompany/TopEmployeesCompany";
import DepartmentPlan from "./components/cards/DepartmentPlan/DepartmentPlan";
import TopDepartments from "./components/cards/TopDepartments/TopDepartments";
import CompanyPlan from "./components/cards/CompanyPlan/CompanyPlan";
import DepartmentsPlan from "./components/cards/DepartmentsPlan/DepartmentsPlan";
import LTWCompany from "./components/cards/LTWCompany/LTWCompany";
import UsersPlan from "./components/cards/UsersPlan/UsersPlan";
import UserPlan from "./components/cards/UserPlan/UserPlan";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { useIsMobile } from "@/shared/lib/useIsMobile";
import { useEffect, useState } from "react";
import { HISTORY_UPDATED } from "../PlanHistory/utils";
import { COMMERCIAL_DEPARTMENT_ID, isCommercialDirector, isSalesSystemAccount } from '@/features/Auth/lib/salesAccess';
import { useDashboard } from './lib/useDashboard';

/** Невидимый плейсхолдер того же размера, что и TopEmployeesCompany (col=7, row=8) */
function TopEmployeesCompanyPlaceholder() {
  return (
    <GridItem col={7} rowSpan={8} height={8 * 50}>
      <div aria-hidden />
    </GridItem>
  );
}

/** Руководитель: есть подчинённые или руководит отделом (role = head) */
function isHeader(user: {
  bx?: { sub_users?: unknown[]; department?: { id: number; role: string }[] };
} | null): boolean {
  if (!user?.bx) return false;
  const hasSubUsers = (user.bx.sub_users?.length ?? 0) > 0;
  const isHeadOfDepartment = user.bx.department?.some((d) => d.role === "head") ?? false;
  return hasSubUsers || isHeadOfDepartment;
}

function Dashboard() {
  const [historyRevision, setHistoryRevision] = useState(0);
  useEffect(() => {
    const refresh = () => setHistoryRevision(value => value + 1);
    window.addEventListener(HISTORY_UPDATED, refresh);
    return () => window.removeEventListener(HISTORY_UPDATED, refresh);
  }, []);
  const { user } = useAuth();
  const { selectedDepartment } = useDashboard();
  const isMobile = useIsMobile();
  const systemAccount = isSalesSystemAccount(user);
  const director = isCommercialDirector(user);
  const commercialOverview = director || (systemAccount && (
    selectedDepartment == null || Number(selectedDepartment) === COMMERCIAL_DEPARTMENT_ID
  ));
  const departmentPerspective = systemAccount && selectedDepartment != null &&
    Number(selectedDepartment) !== COMMERCIAL_DEPARTMENT_ID;
  const header = isHeader(user);

  return (
    <Grid key={historyRevision}>
      <CompanyPlan />

      {isMobile ? null : commercialOverview ? (
        <>
          <DepartmentsPlan />
          <TopDepartments />
          <LTWCompany />

        </>
      ) : (departmentPerspective || header) ? (
        <>
          <TopEmployeesCompany />
          <DepartmentPlan col={16} />
          <TopEmployeesDepartment />
          <UsersPlan />
          <TopDepartments />
        </>
      ) : (
        /* Менеджер: план отдела, топ по отделу, LTW, личный план, топ отделов */
        <>
          <DepartmentPlan />
          <UserPlan />
          <TopEmployeesCompany />
          <LTWCompany />
          <TopEmployeesDepartment />
          <TopDepartments />
        </>
      )}
    </Grid>
  );
}

export default Dashboard;
